export default defineNuxtRouteMiddleware((to) => {
  if (to.params.id) return
  return navigateTo(`${to.fullPath}/rules`, { replace: true })
})
